import type { RentalMarketService } from './RentalMarketContext'

/**
 * Creates a static rental market service that returns
 * pre-fetched data. Used in read-only mode (public app).
 */
export const createStaticRentalMarketService = (
  marketAggregations: any
): RentalMarketService => {
  const data = marketAggregations?.rental || {}

  return {
    getRentalPriceEvolutionData: async () => ({
      aggregations: data.priceEvolution || {},
    }),
    getRentalPriceM2EvolutionData: async () => ({
      aggregations: data.priceEvolutionPerSqm || {},
    }),
    getRentalAvailabilityData: async () => ({
      aggregations: data.availability || {},
    }),
    getRentalPricePerRoomData: async () => ({
      aggregations: data.pricePerRoom || {},
    }),
    getRentalPriceM2PerRoomData: async () => ({
      aggregations: data.priceM2PerRoom || {},
    }),
    getRentalDistributionData: async () => ({
      aggregations: data.distribution || {},
    }),
  }
}
